import PropTypes from "prop-types";

import AddTextSetIcon from "@/icons/AddTextSetIcon";
import contentTypes from "@/view/constants/contentTypes";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import SecondaryActionButton from "../../SecondaryActionsToolbar/SecondaryActionButton";
import { addActionIconCss } from "./AddAction.style";
import AddMobileAction from "./AddMobileAction";
import AddOptions from "./AddOptions";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevel: PropTypes.object,
  disabled: PropTypes.bool,
  activeSubMenu: PropTypes.string,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  setActiveSubMenu: PropTypes.func,
  showLockIcon: PropTypes.bool,
  user: PropTypes.object,
};

const AddAction = ({
  activeSubMenu,
  contentId,
  contentType,
  currentLevel,
  disabled,
  hoverLabel,
  isMobile,
  setActiveSubMenu,
  showLockIcon,
  user,
}) => {
  const contentIsVideo = contentType === contentTypes.INTERACTIVE_VIDEO;

  const actionName = "Add";

  const eventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName,
    streamProperties: {
      content_type: getEventPropertiesContentType(contentType),
      description: "Add to Text Set",
      content_id: contentIsVideo ? contentId : currentLevel?.id,
    },
  };

  const popOutContents = (
    <AddOptions
      contentId={contentId}
      contentType={contentType}
      currentLevel={currentLevel}
      isMobile={isMobile}
      showLockIcon={showLockIcon}
      user={user}
    />
  );

  const icon = <AddTextSetIcon css={addActionIconCss} />;

  const ariaProps = {
    "aria-label": "Add to Text Set",
  };

  if (isMobile) {
    return (
      <AddMobileAction
        actionName={actionName}
        activeSubMenu={activeSubMenu}
        disabled={disabled}
        eventProperties={eventProperties}
        icon={icon}
        popOutContents={popOutContents}
        setActiveSubMenu={setActiveSubMenu}
        showLockIcon={showLockIcon}
        dataProps={{ "data-qa-selector": "add-to-textset" }}
      />
    );
  }

  return (
    <SecondaryActionButton
      ariaProps={ariaProps}
      disabled={disabled}
      eventProperties={eventProperties}
      hoverLabel={hoverLabel}
      icon={icon}
      popOutContents={popOutContents}
      showLockIcon={showLockIcon}
      title={actionName}
      dataProps={{ "data-qa-selector": "add-to-textset" }}
    />
  );
};

AddAction.propTypes = propTypes;

export default AddAction;
